import { SHARED_PROFESSIONAL_ROLES } from "./property-memberships"

export const USER_MAIN_ROLES = [
	"investor",
	...SHARED_PROFESSIONAL_ROLES,
] as const
export type UserMainRole = (typeof USER_MAIN_ROLES)[number]
